export default __webpack_public_path__ + "static/media/Logout-white.479bb9e8.svg";